import {
  ACTIVITIES_CONTENT_STATUS_DRAFT,
  ACTIVITIES_CONTENT_STATUS_PUBLISHED,
} from 'global/constants';
import { InquisitiveActivitiesContentStatus } from 'global/graphql/scalars.type';

export function canAccessEditActivities(props: {
  canEditActivities: boolean;
  canBuildActivities: boolean;
  status: InquisitiveActivitiesContentStatus;
}) {
  // once published only ActivityPublishers can access Edit mode
  if (
    (props.status === ACTIVITIES_CONTENT_STATUS_PUBLISHED &&
      props.canEditActivities) ||
    (props.status === ACTIVITIES_CONTENT_STATUS_DRAFT &&
      props.canBuildActivities)
  ) {
    return true;
  }

  return false;
}
